export default {
  "content": "<g clip-path=\"url(#clip0)\" fill=\"#EBECF2\"><path d=\"M20.975 16.592l-.009-.017c-1.88-3.55-.96-7.785 1.974-10.314.903-.777 1.349-2.043.796-3.087L22.056 0c-7.173 3.601-9.987 12.19-6.285 19.183l.009.017 5.195-2.608zM8.039 16.592l-.009-.017c-1.88-3.55-.96-7.785 1.974-10.314.902-.777 1.349-2.043.796-3.087L9.12 0C1.947 3.601-.867 12.19 2.835 19.183l.009.017 5.195-2.608z\"/></g><defs><clipPath id=\"clip0\"><path transform=\"rotate(-180 24 19.2)\" fill=\"#fff\" d=\"M24 19.2h24v19.2H24z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "20",
    "viewBox": "0 0 24 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};